/* Ott-common */
import { normalize } from '@dtvgo/typed-normalizr';
import { AuthType } from '@dtvgo/axios-interceptor-auth';
import { OrbisResourceType } from '@dtvgo/constants';

/* Utils */
import { StationEntity, LiveContentEntity } from '../../utils';

/**
 * @param {import('axios').AxiosInstance} backendAxiosInstance
 */
export default function schedules(backendAxiosInstance) {
  /**
   * @typedef GetSchedulesParams
   * @type {object}
   * @property {string[]} stationIDs
   * @property {string} region
   * @property {Date} fromDatetime
   * @property {Date} toDatetime
   * @property {number} count
   * @property {'es' | 'en' | 'pt'} [language]
   * @property {number} [offset]
   * @property {OrbisResourceType[]} [types]
   */

  /**
   * @param {GetSchedulesParams} params
   */
  async function getSchedules({
    fromDatetime, toDatetime, stationIDs, ...restParams
  }) {
    const response = await backendAxiosInstance.get('/content/v1/Schedules', {
      params: {
        fromDatetime: fromDatetime.toISOString(),
        toDatetime: toDatetime?.toISOString(),
        stationIDs: stationIDs.join(','),
        ...restParams,
      },
      authType: AuthType.SESSION_TOKEN,
    });

    response.normalizedData = normalize(response.data, [StationEntity]);

    return response;
  }

  /**
   * @typedef GetScheduleByIdParams
   * @type {object}
   * @property {'es' | 'en' | 'pt'} [language]
   */
  /**
   * @param {OrbisResourceType} resourceType
   * @param {string} scheduleId
   * @param {GetScheduleByIdParams} [params]
   */
  async function getScheduleById(resourceType, scheduleId, params) {
    let resourceTypeUrl;

    switch (resourceType) {
      case OrbisResourceType.LIVE_MOVIE:
        resourceTypeUrl = 'Movies';
        break;
      case OrbisResourceType.LIVE_COMPETITION:
        resourceTypeUrl = 'Competitions';
        break;
      case OrbisResourceType.LIVE_TEAM_COMPETITION:
        resourceTypeUrl = 'TeamCompetitions';
        break;
      case OrbisResourceType.LIVE_EPISODE:
        resourceTypeUrl = 'Episodes';
        break;
      case OrbisResourceType.LIVE_EVENT:
        resourceTypeUrl = 'Events';
        break;
      default:
        throw new Error('A known resourceType is required');
    }

    const response = await backendAxiosInstance.get(`/content/v1/Schedules/${resourceTypeUrl}/${scheduleId}`, {
      params,
      authType: AuthType.SESSION_TOKEN,
    });

    response.normalizedData = normalize(response.data, LiveContentEntity);

    return response;
  }

  return {
    getSchedules,
    getScheduleById,
  };
}
